<template>
</template>

<script>
export default {
  name: 'home',
  created() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue